/**
 * Client-Safe Environment Configuration
 *
 * Contains NEXT_PUBLIC_* variables that are safe to access in client components.
 * These are inlined at build time by Next.js.
 *
 * NOTE: Do NOT add any server-only secrets here. Only NEXT_PUBLIC_* variables
 * should be exported from this module.
 */

// ============================================================================
// Application URLs
// ============================================================================

export const NEXT_PUBLIC_APP_URL = process.env.NEXT_PUBLIC_APP_URL || "https://app.etheraguru.com";

export const NEXT_PUBLIC_SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || "https://www.etheraguru.com";

export const NEXT_PUBLIC_ADMIN_URL =
  process.env.NEXT_PUBLIC_ADMIN_URL || "https://admin.etheraguru.com";

export const NEXT_PUBLIC_SIGN_UP_URL =
  process.env.NEXT_PUBLIC_SIGN_UP_URL || "https://signin.etheraguru.com/sign-up";

export const NEXT_PUBLIC_SIGN_IN_URL =
  process.env.NEXT_PUBLIC_SIGN_IN_URL || "https://signin.etheraguru.com";

// ============================================================================
// Environment Identifiers
// ============================================================================

export const NODE_ENV = process.env.NODE_ENV || "development";

export const NEXT_PUBLIC_APP_ENVIRONMENT = process.env.NEXT_PUBLIC_APP_ENVIRONMENT || "local";

export const NEXT_PUBLIC_BUILD_VERSION = process.env.NEXT_PUBLIC_BUILD_VERSION;

export const NEXT_PUBLIC_WEB_BUILD_NUMBER =
  process.env.NEXT_PUBLIC_WEB_BUILD_NUMBER || process.env.NEXT_PUBLIC_BUILD_VERSION || "local-dev";

export const NEXT_PUBLIC_WEB_BUILD_ID =
  process.env.NEXT_PUBLIC_WEB_BUILD_ID || `web-${NEXT_PUBLIC_WEB_BUILD_NUMBER}`;

export const NEXT_PUBLIC_WEB_BUILD_SHA = process.env.NEXT_PUBLIC_WEB_BUILD_SHA || "local";

export const NEXT_PUBLIC_WEB_BUILT_AT = process.env.NEXT_PUBLIC_WEB_BUILT_AT || "";

// ============================================================================
// Debug / Feature Flags
// ============================================================================

export const NEXT_PUBLIC_EG_DEBUG_UI = process.env.NEXT_PUBLIC_EG_DEBUG_UI === "true";

// ============================================================================
// PostHog Analytics (public keys only)
// ============================================================================

export const NEXT_PUBLIC_POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY;
export const NEXT_PUBLIC_POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST;

// ============================================================================
// WhatsApp Contact (public site widget + social links)
// ============================================================================

/** WhatsApp number with country code, e.g. "447990300670" */
export const NEXT_PUBLIC_WHATSAPP_PHONE = process.env.NEXT_PUBLIC_WHATSAPP_PHONE || "";
